<template>
<div id="index">


  <div class="common-level-rail">
    <el-button size="small" type="primary" @click="$refs.addEdit.show()" icon="el-icon-plus" v-auth="'/appraisal/fineness/add'">添加成色</el-button>
  </div>

  <div class="product-content">
    <div class="table-wrap">
      <el-table size="small" :data="list" >
        <el-table-column prop="name" label="成色名称"></el-table-column>
        <el-table-column prop="sort" label="排序"></el-table-column>
        <el-table-column prop="create_time" label="添加时间"></el-table-column>
        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <el-button @click="$refs.addEdit.show(scope.row)" type="text" size="small" v-auth="'/appraisal/fineness/edit'">编辑</el-button>
            <el-button @click="deleteTap(scope.row)" type="text" size="small" v-auth="'/appraisal/fineness/delete'">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>

  <div class="pagination">
    <el-pagination
      @current-change="pageChange"
      background
      :current-page="searchObj.page"
      :page-size="searchObj.list_rows"
      layout="total, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
  </div>


  <AddEdit ref="addEdit"  @refresh="getData"></AddEdit>


</div>
</template>

<script>
import AddEdit from './addEdit.vue';
import AppraisalApi from '@/api/appraisal'
export default {
  components:{AddEdit},
  data() {
    return {
      searchObj:{
        page:1,
        list_rows:10,
      },
      list: [],
      total:0,
    }
  },
  created(){
    this.getData()
  },
  methods:{

    getData(){
      AppraisalApi.finenessIndex(this.searchObj).then(result=>{
        let list=result.data.list
        this.list=list.data
        this.total=list.total
      })
    },

    // 删除
    deleteTap(e){
      this.$confirm('确认删除当前成色吗？','提示',{type: 'warning'}).then(() => {
        AppraisalApi.finenessDelete({fineness_id:e.fineness_id}).then(result=>{
          this.$message({
            message: '删除成功',
            type: 'success'
          });
          this.getData()
        })
      })
    },

    // 分页
    pageChange(e){
      this.searchObj.page=e
      this.getData()
    },

  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/views/appraisal/fineness/index.vue